import script from "./EasyEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./EasyEditor.vue?vue&type=script&setup=true&lang=js"

import "./EasyEditor.vue?vue&type=style&index=0&id=6c013470&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c013470"]])

export default __exports__